import { api } from "./client";
import type {
  BodyCompositionHistory,
  BodyCompositionLog,
  WeeklyCheckinStatus,
} from "@/types";

export async function logComposition(payload: {
  weight_kg: number;
  body_fat_pct?: number | null;
  notes?: string | null;
  measured_at?: string;
}): Promise<BodyCompositionLog> {
  const { data } = await api.post<BodyCompositionLog>("/body/composition", payload);
  return data;
}

export async function parseTanitaText(payload: {
  text: string;
  notes?: string | null;
}): Promise<BodyCompositionLog> {
  const { data } = await api.post<BodyCompositionLog>(
    "/body/composition/tanita-parse",
    payload,
  );
  return data;
}

export async function getBodyHistory(days = 180): Promise<BodyCompositionHistory> {
  const { data } = await api.get<BodyCompositionHistory>(
    `/body/composition/history?days=${days}`,
  );
  return data;
}

export async function deleteComposition(id: number): Promise<void> {
  await api.delete(`/body/composition/${id}`);
}

export async function getWeeklyCheckinStatus(): Promise<WeeklyCheckinStatus> {
  const { data } = await api.get<WeeklyCheckinStatus>(
    "/body/composition/weekly-checkin-needed",
  );
  return data;
}
